import { useState, useEffect } from 'react'
import { useAuthorization } from '@/hooks'

export const AnyAccess = ({ permissions = [], fallback = null, children }) => {
  const { hasAccess } = useAuthorization({ redirection: { enable: false } })
  const [ok, setOk] = useState(false)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      const checks = await Promise.all(
        permissions.map(p => hasAccess(p).catch(() => false))
      )
      if (mounted) setOk(checks.some(Boolean))
    })()
    return () => { mounted = false }
  }, [hasAccess, JSON.stringify(permissions)])

  if (!ok) return fallback
  return children
}